<ul class="view-labels">
  <li 
    role="button"
    [attr.aria-label]="label.title"
    class="view-labels__item"
    [ngClass]="{'view-labels__item--selected': (selectedLabel$ | async)?.id === label.id}"
    *ngFor="let label of (labels$ | async)"
    (click)="handleLabelClick(label)"
    (keyup.enter)="handleLabelClick(label)"
    tabindex="0">
    <div class="view-labels__pre">
      <div class="view-labels__pin">
        <app-label-pin [label]="label" [sequence]="getLabelSequence(label)"></app-label-pin>
      </div>
    </div>

    <div class="view-labels__body">
      <div class="view-labels__title html" [innerHTML]="label.title | markdown"></div>
    </div>
  </li>
</ul>